<script setup lang="ts">
import { checkboxProps } from 'naive-ui';

// 1:1 wrapper: the size, radius and ink colours live in the theme's Checkbox
// overrides, so every checkbox in the app moves together.
const props = defineProps(checkboxProps);
</script>

<template>
  <n-checkbox v-bind="props">
    <slot />
  </n-checkbox>
</template>
